<template>
  <b-modal
    id="modal-multi-3"
    size="sm"
    title="Confirmación"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showConfirmacionDelegado"
  >
    <b-card-text v-if="action == 'delete'" class="my-1">
      El delegado será eliminado del periodo actual. Se perderán los datos asociados al mismo. <br />
      <br />
      ¿ Deseas continuar ?
    </b-card-text>
    <template #modal-footer>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        class="float-right mr-1"
        @click="close"
      >
        Cancelar
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="float-right"
        @click="saveAccion"
      >
        Aceptar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BCardText, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  //   ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    playerSelected: Object,
    action: String,
    movimiento: String,
  },
  setup(props, { emit }) {
    const { postApi } = apiCall()

    async function deletePlayer() {
      const path = 'ApiInscripciones/deleteDelegadoHistorial'
      // console.log(props)
      const dataSend = {
        idHistorial: props.playerSelected.id_historial_delegado,
        movimiento: props.movimiento,
        idUserIngresa: USER().id_usuario,
        rol: USER().rol,
        idTorneo:
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      }
      const response = await postApi(URL, path, dataSend)
      if (response.flag === 'si') {
        // console.log('eliminado')
        emit('eliminado')
      }
      store.commit(
        'someVariables/UPDATE_SHOW_CONFIRMACION_DELEGADO',
        // eslint-disable-next-line
        false,
      )
    }

    async function deletePase() {
      const path = 'ApiInscripciones/deletePase'
      // console.log(props.playerSelected)
      const dataSend = {
        idPase: props.playerSelected.id_pase,
      }
      const response = await postApi(URL, path, dataSend)
      if (response.flag === 'si') {
        // console.log('eliminado')
        emit('eliminadoPase', props.playerSelected)
        store.commit(
          'someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION',
          // eslint-disable-next-line
          false,
        )
      }
    }
    async function updateSolicitudRevision() {
      const path = 'ApiConfiguration/updateInscripcionEquipo'
      const response = await postApi(
        URL,
        path,
        // eslint-disable-next-line
        props.playerSelected.id_inscripcion,
      )
      // console.log(props.playerSelected)
      if (response.flag === 'si') {
        emit('revisado')
        store.commit(
          'someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION',
          // eslint-disable-next-line
          false,
        )
      } else {
        // this.$toast(
        //   {
        //     component: ToastificationContent,
        //     props: {
        //       title: 'ERROR no se pudo actualizar',
        //       icon: 'AlertCircleIcon',
        //       variant: 'danger',
        //       solid: true,
        //     },
        //   },
        //   {
        //     position: 'top-center',
        //     // eslint-disable-next-line
        //   }
        // )
      }
    }
    function saveAccion() {
      if (props.action === 'delete') {
        deletePlayer()
      }
    }

    function close() {
      store.commit(
        'someVariables/UPDATE_SHOW_CONFIRMACION_DELEGADO',
        // eslint-disable-next-line
        false,
      )
    }
    return {
      deletePlayer,
      close,
      saveAccion,
      updateSolicitudRevision,
      deletePase,
    }
  },
}
</script>
